export const DEFAULT_TERRITORY_LOGO = '/images/default-territory-logo.svg';
export const NUMBER_OF_PROFILE_IMAGES = 5;
export const NUMBER_OF_PROFILE_IMAGES_TERRITORY_V2 = 3;
